const createEventTarget = () => {
	class EventTarget {
		constructor() {
			this.listeners = {};
		}

		addEventListener(type, callback) {
			if (!(type in this.listeners)) {
				this.listeners[type] = [];
			}
			this.listeners[type].push(callback);
			return callback;
		}

		removeEventListener(type, callback) {
			if (!(type in this.listeners)) {
				return;
			}
			const stack = this.listeners[type];
			for (let i = 0; i < stack.length; i++) {
				if (stack[i] === callback) {
					stack.splice(i, 1);
					return;
				}
			}
		}

		dispatchEvent(action) {
			if (!(action.type in this.listeners)) {
				return true;
			}
			const stack = this.listeners[action.type].slice();

			for (let i = 0, l = stack.length; i < l; i++) {
				stack[i].call(this, action.payload);
			}
		}
	}

	return new EventTarget();
};

export default createEventTarget;
